import {
  Checkbox as NextUICheckbox,
  type CheckboxProps as NextUICheckboxProps,
} from '@heroui/checkbox';

interface CheckboxProps extends NextUICheckboxProps {}

const Checkbox = (props: CheckboxProps) => {
  return (
    <NextUICheckbox
      disableAnimation
      color="primary"
      radius='sm'
      {...props}
    />
  );
};

export default Checkbox;
